import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {RoleService} from "../../../services/role.service";
import {PermissionService} from "../../../services/permission.service";
import {Role} from "../../../interfaces/role";
import {UserService} from "../../../services/user.service";
import {Router} from "@angular/router";
import {Response} from "../../../interfaces/response";
import {Permission} from "../../../interfaces/permission";


@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.scss']
})
export class UserCreateComponent implements OnInit {
  form: FormGroup;
  roles: Role[] = [];
  permissions: Permission[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private roleService: RoleService,
    private permissionService: PermissionService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      first_name: '',
      last_name: '',
      email: '',
      role_id: '',
      permissions: this.formBuilder.array([])
    });

    this.permissionService.all().subscribe(
      (res: Response) => {
        this.permissions = res.data["data"];
      //  console.log(this.permissions)
        this.permissions.forEach((p: Permission) => {
          this.permissionArray.push(
            this.formBuilder.group({
              value: false,
              id: p.id
            })
          )
        });
      }
    )

    this.roleService.all().subscribe(
      (res: Response) => {
        this.roles = res.data["data"];
      }
    )
  }

  get permissionArray() {
    return this.form.get('permissions') as FormArray;
  }

  submit() {
    //console.log(this.form.getRawValue());
    const data = this.form.getRawValue();

    this.userService.create(data).subscribe(
      res => {
        this.router.navigate(['/users']);
      }
    );
  }
}
